import { render, staticRenderFns } from "./SetFieldsMain.vue?vue&type=template&id=785f4f5b&scoped=true"
import script from "./SetFieldsMain.vue?vue&type=script&lang=js"
export * from "./SetFieldsMain.vue?vue&type=script&lang=js"
import style0 from "./SetFieldsMain.vue?vue&type=style&index=0&id=785f4f5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785f4f5b",
  null
  
)

export default component.exports